/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import moment, { isDate } from "moment";

function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}

function formatDate(date, format = "DD/MM/YYYY") {
  return isDate(new Date(date)) ? moment(new Date(date)).format(format) : date;
}

export const filter = {
  fomatDate(date, format = "DD/MM/YYYY") {
    return formatDate(date, format);
  },

  fomatDateYearMD(date, format = "YYYY/MM/DD") {
    return formatDate(date, format);
  },

  fomatDate2(date, format = "YYYY/MM/DD") {
    return formatDate(date, format);
  },

  formatDateJa(date, format = "YYYY年MM月DD日") {
    return formatDate(date, format);
  },

  formatDateLocal(date) {
    date = date.substring(0, 19);
    const array = date.split('T');

    return array[0].replace(/-/g, '/');
  },

  joinBy(data, field) {
    if (Array.isArray(data)) {
      return data.map(i => i[field]).join(', ');
    }

    return '';
  },

  filterCurrentScore(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));
    let total = 0;
    for (let index = 0; index < arrClone.length; index++) {
      total += arrClone[index].max_score == 13 ? 0 : arrClone[index].current_score;
    }
    return total;
  },

  filterMaxScore(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));
    let total = 0;
    for (let index = 0; index < arrClone.length; index++) {
      total += arrClone[index].max_score == 13 ? 0 : arrClone[index].max_score;
    }
    return total;
  },

  filterSurveyType1(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));

    const data = arrClone.find((el) => el.survey_type === 1);
    return data ? data.current_score  : "-";
  },

  filterSurveyType2(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));
    const data = arrClone.find((el) => el.survey_type === 2);
    if (!data) return "-"
    if (data.current_score < 7) {
      return  0;
    } else if (data.current_score < 16 && data.current_score >= 7) {
      return  1;
    } else if (data.current_score < 25 && data.current_score >= 16) {
      return  2;
    } else {
      return  3;
    }
  },

  filterSurveyType3(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));
    const data = arrClone.find((el) => el.survey_type === 3);
    if (data) {
      return data.sub_histories.reduce((acc, el) => acc + (el.max_score == 13 ? 0 : el.current_score), 0) ?? "-";
    } else {
      return "-";
    }
  },

  filterSurveyType4(array = []) {
    const arrClone = JSON.parse(JSON.stringify(array));
    const data = arrClone.find((el) => el.survey_type === 3);
    if (data && data.current_harris !== null) {
      return data.current_harris;
    } else {
      return "-";
    }
  },

  fomatCurrency(value) {
    if (isFloat(value) || isInt(value)) {
      return value.toLocaleString("it-IT", {
        style: "currency",
        currency: "VND",
      });
    }
  },

  filterLabelOptionObj(
    value = null,
    optionKey = null,
    filedReturn = "",
    array = []
  ) {
    if (!value || array.length === 0 || !optionKey || !filedReturn) {
      return;
    }
    const current = array.find((e) => e[optionKey] === value);
    if (!current) {
      return;
    }
    return current[filedReturn];
  },

  wrapTotalHiscore(arr = []) {
    let current = 0;
    let max = 0;
    if (arr.length > 0 || arr) {
      arr.forEach((e) => {
        current = current + (e.current_score ? e.current_score : 0);
        max = max + (e.max_score ? e.max_score : 0);
      });
    }
    return { max, current };
  },

  wrapLabelHipscoreWithValue({ max, current }) {
    return `${current}/${max}点`;
  },
};
